import runicMemoriseLogo from "../assets/Logo.png";
import menuStyles from "../Components/menu-styles.module.scss";

type menuProps = {
  onStart: () => void;
};

const Menu: React.FC<menuProps> = ({ onStart }) => {
  return (
    <div data-testid='Menu' className={menuStyles.menuContainer}>
      <img
        className={menuStyles.mainLogo}
        src={runicMemoriseLogo}
        alt='Runic Memorise Logo'
      />
      <button className={menuStyles.startButton} onClick={onStart}>
        Start
      </button>
    </div>
  );
};
export default Menu;
